export const isProd: boolean = process.env.NEXT_PUBLIC_BUILD_ENV === 'production';

export const isDev: boolean =
  process.env.NEXT_PUBLIC_BUILD_ENV === 'development' ||
  process.env.NEXT_PUBLIC_BUILD_ENV === 'local';
export const s3 = process.env.NEXT_PUBLIC_S3_URL;
export const assetPrefix =
  isProd && process.env.NEXT_PUBLIC_ASSET_PREFIX ? process.env.NEXT_PUBLIC_ASSET_PREFIX : '/';
